import BaseApiRequest from "./BaseApiRequest";
import { GET_GETTING_STARTED_VAULT } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetGettingStartedVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(GET_GETTING_STARTED_VAULT);
  };

  getBody = () => this.body;
}
